<template>
  <div class="comment-list__item actions-dropdown__hoverable">
    <div class="comment-list__avatar">
      <img :src="comment.author.avatar" :alt="comment.author.name" />
    </div>

    <article class="comment-list__content">
      <a :href="comment.author.profile" class="comment__author">
        {{ comment.author.name }}
      </a>

      <span class="comment__time">
        <span>{{ comment.created_at }}</span>
      </span>

      <div class="actions-dropdown dropdown open-left" v-if="authenticated">
        <a href="#" data-toggle="dropdown">
          <span class="caret"></span>
        </a>
        <ul class="dropdown-menu links">
          <li v-if="reply">
            <a href="#" @click.prevent="toggleReply">Reply</a>
          </li>
          <li v-if="comment.can_report">
            <a href="#" @click.prevent="reportComment">Report</a>
          </li>
          <li v-if="comment.can_delete">
            <a href="#" @click.prevent="removeComment">Delete</a>
          </li>
        </ul>
      </div>

      <div class="comment__content" v-html="comment.text"></div>
    </article>

    <div class="comment__replies">
      <comments-list v-if="comment.replies.length > 0" :comments="comment.replies" :reply="reply" />
      <comment-form
        v-if="showReplyForm"
        @handleSubmit="createReply"
        ref="replyForm"
        :reply="reply"
      />
    </div>
  </div>
</template>

<script>
import CommentForm from "./CommentForm";
import CommentsList from "./CommentsList";

export default {
  name: "CommentsListItem",
  components: {
    CommentForm,
    CommentsList
  },
  props: ["reply", "comment"],
  data: function() {
    return {
      showReplyForm: false,
      authenticated: Grabcad.authenticated
    };
  },
  methods: {
    toggleReply: function() {
      this.showReplyForm = !this.showReplyForm;
    },
    reportComment: function() {
      this.$eventHub.$emit("reportComment", this.comment);
    },
    removeComment: function() {
      axios.delete("/comments/comments/" + this.comment.id).then(() => {
        this.$emit("removeComment", this.comment);
      });
    },
    createReply: function(content) {
      const payload = {
        body: content,
        parent_id: this.comment.id
      };

      return axios
        .post("/comments/comments", payload)
        .then(response => {
          this.comment.replies.push(response.data);
          this.$refs.replyForm.resetForm();
        })
        .finally(() => {
          this.$refs.replyForm.resetSubmitting();
        });
    }
  }
};
</script>
